export const DetectorActions = Object.freeze({
  DETECTOR_ENABLED_EXPOSURE_EVENT: 'DETECTOR_ENABLED_EXPOSURE_EVENT',
} as const);
